import { useAppDispatch } from '@/store/hooks';
import { setAllAttendeesSearch } from '@/store/slices/audiences';
import { UserStatus } from '@/types/all-attendees.types';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import SearchInput from '@ui/search-input/search-input';
import { NavLink } from 'react-router-dom';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import ProfilesRegistrationStatusFilter from './profiles-registration-status-filter';
import useFixedDrawer from '@ui/fixed-drawer/use-fixed-drawer';
import CampaignUsageDropdown from './campaign-usage-dropdown';

const STATUS_LABEL: Record<UserStatus, string> = {
  [UserStatus.REGISTERED]: 'Registered',
  [UserStatus.ATTENDED]: 'Attended',
  [UserStatus.NO_SHOWS]: 'No Shows',
};

type ProfileListActionsProps = {
  lockedStatus?: UserStatus;
};

const ProfileListActions = ({ lockedStatus }: ProfileListActionsProps) => {
  const dispatch = useAppDispatch();
  const { setOpenDrawer } = useFixedDrawer({ id: 'profile-columns-select' });

  return (
    <Container className="flex ai-center jc-space-between margin-b-16" height="32px">
      <div className="flex ai-center">
        <NavLink className="flex ai-center gap-8" to="../lists" relative="path" replace>
          <Icon name={ICONS.ARROW_LEFT} size={20} color="var(--global-ico-text-1)" />
          <Text className="H4" design="GlobalIcoText1">
            {lockedStatus ? STATUS_LABEL[lockedStatus] : 'All Profiles'}
          </Text>
        </NavLink>
        {lockedStatus && <CampaignUsageDropdown status={lockedStatus} />}
      </div>

      <Container className="flex ai-center gap-8">
        <SearchInput
          onSubmit={(search) => dispatch(setAllAttendeesSearch(search))}
          onClear={() => dispatch(setAllAttendeesSearch(''))}
          expandOnFocus
          width="300px"
          trackInParams
          debounceTime={500}
          isClearable
          isBorderless
        />

        {!lockedStatus && <ProfilesRegistrationStatusFilter />}

        <Button
          design="LocalBttnSec"
          onClick={setOpenDrawer}
          className="flex fd-row jc-center ai-center radius-full padding-0"
          width="32px"
          height="32px"
        >
          <Icon name={ICONS.COLUMN_SETTINGS} size={12} />
        </Button>
      </Container>
    </Container>
  );
};

export default ProfileListActions;
